// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParallaxCta_wrapper__1pKAB","image":"ParallaxCta_image__yoh_E","parallaxItem":"ParallaxCta_parallaxItem__kVCjq"};